import React from 'react'

const About = () => {
    return (
        <div>
            Hello, This is About
        </div>
    )
}

export default About;